import { NUMBER_FORMAT } from "core/constants/format/numberFormat";

export const formatNumber = (num, format) => {
    if (num === null || num === undefined) return "";

    let separator, decimal = null;
    switch (format) {
        case NUMBER_FORMAT.FORMAT_1:
            separator = " ";
            decimal = ".";
            break;
        case NUMBER_FORMAT.FORMAT_2:
            separator = ",";
            decimal = ".";
            break;
        case NUMBER_FORMAT.FORMAT_3:
            separator = ".";
            decimal = ",";
            break;
        case NUMBER_FORMAT.FORMAT_4:
            separator = " ";
            decimal = ",";
            break;
        case NUMBER_FORMAT.FORMAT_5:
            separator = "";
            decimal = ".";
            break;
        case NUMBER_FORMAT.FORMAT_6:
            separator = "";
            decimal = ",";
            break;
        default:
            separator = " ";
            decimal = ".";
            break;
    }
    const str = num.toString();
    const parts = str.split(".");
    if (separator !== "") {
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    }
    return parts.join(decimal);
}